<ng-template #jobInfo let-showLogsButton="showLogsButton" let-jobId="jobId" let-eventId="eventId">
  <y42-job-info-content
    [jobId]="jobId"
    [showLogsButton]="showLogsButton"
    (showLogs)="openLogsDialog(jobId, eventId)"
    (showRequest)="viewRequest(jobId)"
  ></y42-job-info-content>
</ng-template>

<ng-container *ngIf="state.models.length === 1">
  <ng-container
    *ngTemplateOutlet="
      jobInfo;
      context: {
        jobId: state.models[0].job.request_id,
        eventId: state.models[0].eventId,
        showLogsButton: showLogsButton
      }
    "
  ></ng-container>
</ng-container>

<ng-container *ngIf="state.models.length > 1">
  <mat-expansion-panel
    class="mat-elevation-z0 border-bottom rounded-none"
    *ngFor="let model of state.models; let index = index; trackBy: trackById"
    [expanded]="state.selectedJobIndex === index"
    (expandedChange)="expandJob(index, $event)"
  >
    <mat-expansion-panel-header
      class="p-0 px-[5px]"
      y42StopPropagation
      [expandedHeight]="'45px'"
      [collapsedHeight]="'45px'"
    >
      <mat-panel-title class="mr-[8px]">
        <ng-container *ngIf="model.mode || model.importRowCount; else exportsHeader">
          <y42-job-triggered-by-user-avatar
            *ngIf="model.job.triggeredBy"
            class="mr-[5px]"
            [triggeredBy]="model.job.triggeredBy"
            [clickable]="true"
            [showNonUserLabel]="true"
            [sizePx]="25"
          ></y42-job-triggered-by-user-avatar>

          <span class="truncate text-xs font-normal w-auto flex-1 flex justify-between">
            <span>
              <ng-container *ngIf="model.mode">
                <y42-icon *ngIf="model.modeIcon" class="mr-1 inline" [icon]="model.modeIcon" [size]="15"></y42-icon>
                {{ model.mode }}
              </ng-container>
              <ng-container *ngIf="model.job.details.current_import_row_count">
                +{{ model.importRowCount | formatValueConversion : 'Automatic' }} rows&nbsp;
              </ng-container>
            </span>
            <span class="font-bold"> at {{ model.job.created_at | formatDate : DateTimeFormat.ShortDateTime }} </span>
          </span>
        </ng-container>
        <ng-template #exportsHeader>
          <div class="text-gray-700">Triggered by:</div>
          <y42-job-triggered-by-user-avatar
            *ngIf="model.job.triggeredBy"
            class="mr-[5px]"
            [triggeredBy]="model.job.triggeredBy"
            [clickable]="true"
            [showNonUserLabel]="true"
            [sizePx]="25"
          ></y42-job-triggered-by-user-avatar>
          <span class="font-bold"> at {{ model.job.created_at | formatDate : DateTimeFormat.ShortDateTime }} </span>
        </ng-template>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <ng-container
      matExpansionPanelContent
      *ngIf="state.selectedJobIndex === index"
      [ngTemplateOutlet]="jobInfo"
      [ngTemplateOutletContext]="{
        jobId: state.models[index].job.request_id,
        eventId: state.models[index].eventId,
        showLogsButton: true
      }"
    ></ng-container>
  </mat-expansion-panel>
</ng-container>
